module.exports = __webpack_public_path__ + "static/media/lotion.27878cb6.jpg";